import React from 'react';
import {Trans} from 'react-i18next';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import AsyncAddOnPackage from './addonpackage/async';
import AsyncSubscription from './subscription/async';
import AsyncChangePlan from './changeplan/async';
import {Redirect} from 'react-router';

const parent1 = {
  title: <Trans i18nKey="p.plan.title">Plan & Pricing</Trans>,
  path: '/plan-pricing',
};

export default [
  <SingleColumnLayout
    exact
    key="a"
    path="/plan-pricing/add-on-package/:type"
    component={AsyncAddOnPackage}
    parents={[parent1]}
    title={<Trans i18nKey="p.plan.addonpackage.title">Add-On Package</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="c"
    path="/plan-pricing/subscription"
    className="kt-portlet--solid-gray"
    component={AsyncSubscription}
    parents={[parent1]}
    title={<Trans i18nKey="p.plan.subscription.title">Subscription</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="d"
    path="/plan-pricing/change-plan/:solutionKey"
    component={AsyncChangePlan}
    title={<Trans i18nKey="p.g.account.change.plan.title">Change Plan</Trans>}
    parents={[parent1]}
  />,
  <Redirect
    key="b"
    exact
    from="/plan-pricing"
    to="/plan-pricing/subscription"
  />,
];
